/**
 * Local high scores for free-play endless (time survived).
 */
const KEY = "sots-endless-best-v1";

export type EndlessBest = {
  /** Best survival seconds by difficulty */
  byDifficulty: Partial<Record<string, number>>;
};

function loadRaw(): EndlessBest {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { byDifficulty: {} };
    const parsed = JSON.parse(raw) as EndlessBest;
    if (!parsed || typeof parsed !== "object") return { byDifficulty: {} };
    return { byDifficulty: parsed.byDifficulty ?? {} };
  } catch {
    return { byDifficulty: {} };
  }
}

export function getEndlessBest(difficulty: string): number {
  return loadRaw().byDifficulty[difficulty] ?? 0;
}

/** Returns the new best if this run beat the prior, else null. */
export function recordEndlessScore(
  difficulty: string,
  elapsed: number,
): { best: number; isNewBest: boolean } {
  const data = loadRaw();
  const prev = data.byDifficulty[difficulty] ?? 0;
  const isNewBest = elapsed > prev + 0.05;
  if (isNewBest) {
    data.byDifficulty[difficulty] = elapsed;
    try {
      localStorage.setItem(KEY, JSON.stringify(data));
    } catch {
      /* ignore quota */
    }
  }
  return { best: Math.max(prev, elapsed), isNewBest };
}

export function formatSurviveTime(s: number): string {
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  const tenths = Math.floor((s % 1) * 10);
  if (m <= 0) return `${sec}.${tenths}s`;
  return `${m}:${sec.toString().padStart(2, "0")}`;
}
